import { mkMsToLuxH } from '../../sharedF/timeF/mkMsToLuxHF.mts'

/** @type {<T extends Record<string, unknown>>(row: T) => T} */
export const gameStateMsToLux = mkMsToLuxH(['gameActiveAt'])
